module.exports = __webpack_public_path__ + "img/cmb-pay.aa2422bb.png";